import React, { useEffect, useState } from "react";

import isEmpty from "../../lib/isEmpty";
import { toastAlert } from "../../lib/toastAlert";
import { useNavigate } from "react-router-dom";
import { getAllowNot, allowNotify, getAnnouncement } from "../../actions/users";

// import lib
import { dateTimeFormat } from "../../lib/dateFilter";

export default function Announcement() {
  // state
  const [allowNot, setAllowNot] = useState();
  const [notData, setNotData] = useState([]);
  const [autoLoader, setAutoLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllow();
    fetchNotification();
  }, []);
  const fetchAllow = async () => {
    try {
      const { status, result, loading, message, error } = await getAllowNot();
      setAutoLoader(false);
      if (status == "success") {
        setAllowNot(result.announceNotify);
      } else {
        toastAlert("error", message, "autoSelect");
      }
    } catch (err) {}
  };
  const [page, setpagecount] = useState(1);
  const [count, setCount] = useState(0);
  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);

  const noOfPages = Math.ceil(count / 10);
  const pagesArr = [...new Array(noOfPages)];

  const onPrevPage = () => {
    setpagecount(page - 1);
  };

  const gotoPage = (data) => {
    setpagecount(data);
  };

  const onNextPage = () => {
    setpagecount(page + 1);
  };
  const onPageSelect = (pageNo) => {
    setpagecount(pageNo);
  };

  useEffect(() => {
    let reqdata = {
      page,
      limit: 10,
    };
    fetchNotification(reqdata);
  }, [page]);

  const fetchNotification = async (reqdata) => {
    try {
      const { status, result, loading, message, error } = await getAnnouncement(
        reqdata
      );
      setAutoLoader(false);
      if (status == "success") {
        // console.log(result, "-result");
        setNotData(result.announceData);
        setCount(result.count);
        // setpagecount(result.count);
      } else {
        toastAlert("error", message, "autoSelect");
      }
    } catch (err) {}
  };
  const handleAuto = async (e) => {
    try {
      e.preventDefault();
      setAutoLoader(true);
      const { checked } = e.target;
      let reqData = {
        allowNotify: checked,
        type: "announcement",
      };
      const { status, result, loading, message, error } = await allowNotify(
        reqData
      );
      setAutoLoader(false);
      if (status == "success") {
        toastAlert("success", message);
        setAllowNot(result.announceNotify);
      } else {
        toastAlert("error", message, "autoSelect");
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (noOfPages === page) {
      setCanGoNext(false);
    } else {
      setCanGoNext(true);
    }
    if (page === 1) {
      setCanGoBack(false);
    } else {
      setCanGoBack(true);
    }
  }, [noOfPages, page]);
  return (
    <div className="userContent">
      <div className="flexTitle">
        <h2>Announcement</h2>
        <div className="d-flex">
          {/* <label class="label_large me-3">Allow Notification</label>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              checked={allowNot}
              onClick={(e) => handleAuto(e)}
            />
          </div> */}
          <div>
            <button className="edit_btn" onClick={() => navigate("/dashboard")}>
              Go back
            </button>
          </div>
        </div>
      </div>
      <div className="notification_panel">
        {notData &&
          notData.length > 0 &&
          notData.map((item, i) => {
            return (
              <div>
                <h4>{item.description}</h4>
                <h5>Date {dateTimeFormat(item.createdAt)}</h5>
              </div>
            );
          })}
      </div>
      <br />
      {noOfPages > 1 ? (
        <ul class="pagination">
          {/* <li class="page-item">
            <button
              class="page-link"
              onClick={onPrevPage}
              disabled={!canGoBack}
            >
              {"<<"}
            </button>
          </li>
          {pagesArr.map((num, index) => (
            <li class="page-item">
              <button class="page-link" onClick={() => onPageSelect(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}
          <li class="page-item">
            <button
              class="page-link"
              onClick={onNextPage}
              disabled={!canGoNext}
            >
              {">>"}
            </button>
          </li> */}
          <span>
            Page{" "}
            <strong>
              {page} of {pagesArr.length}
            </strong>{" "}
          </span>
          &nbsp;&nbsp;
          <button onClick={() => gotoPage(1)} disabled={!canGoBack}>
            {"<<"}
          </button>{" "}
          <button onClick={onPrevPage} disabled={!canGoBack}>
            {"<"}
          </button>{" "}
          <button onClick={onNextPage} disabled={!canGoNext}>
            {">"}
          </button>{" "}
          <button onClick={() => gotoPage(noOfPages)} disabled={!canGoNext}>
            {">>"}
          </button>{" "}
        </ul>
      ) : null}
    </div>
  );
}
